import React from 'react';

import { Stack, StackProps } from '@lyearn/ui';

import { useMultiStepContext } from '../../context';

interface StepPanelProps extends StackProps {
  id: string;
}

const StepPanel: React.FC<React.PropsWithChildren<StepPanelProps>> = ({
  children,
  id,
  ...stackProps
}) => {
  const { activeStepId } = useMultiStepContext();

  if (activeStepId !== id) return null;

  return <Stack {...stackProps}>{children}</Stack>;
};

export default StepPanel;
